import { getSupabase } from './supabase/client';
import { getSettings, onSettingsSaved, type AppSettings } from './settings';

/**
 * Özet tercihlerinin sunucu kopyası (`user_preferences`, migration 0020).
 *
 * Bot toplantıları sunucuda — uygulama kapalıyken de — özetleniyor; sunucu
 * özet dilini, şablonu, kuralları ve terimleri buradan okuyor. Kaynak yine
 * bu bilgisayardaki ayarlar: her kayıtta (kısa gecikmeyle) ve oturum başına
 * bir kez buraya yazılıyor. Hata akışı bozmaz, yalnızca günlüğe düşer.
 */

const DEBOUNCE_MS = 1_500;
let timer: NodeJS.Timeout | null = null;
let syncedForUser: string | null = null;

async function currentUserId(): Promise<string | null> {
  const { data } = await getSupabase().auth.getSession();
  return data.session?.user.id ?? null;
}

async function push(settings: AppSettings): Promise<void> {
  const userId = await currentUserId();
  if (!userId) return;
  const { error } = await getSupabase()
    .from('user_preferences')
    .upsert(
      {
        user_id: userId,
        ui_language: settings.uiLanguage,
        summary_language: settings.summaryLanguage,
        summary_template_id: settings.summaryStyle.templateId,
        summary_rules: settings.summaryStyle.rules,
        transcript_terms: settings.transcriptTerms,
        updated_at: new Date().toISOString(),
      },
      { onConflict: 'user_id' }
    );
  if (error) {
    console.error('[prefsSync] tercihler sunucuya yazılamadı:', error.message);
    return;
  }
  syncedForUser = userId;
}

/** Ayar kaydedilince sunucu kopyasını tazele. */
export function startPrefsSync(): void {
  onSettingsSaved((settings) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => void push(settings).catch((err) => console.error('[prefsSync]', err)), DEBOUNCE_MS);
  });
}

/** Oturum başına bir kez (giriş yapılınca / hesap değişince) mevcut ayarları yaz. */
export async function ensurePrefsSynced(): Promise<void> {
  const userId = await currentUserId();
  if (!userId || syncedForUser === userId) return;
  await push(await getSettings());
}
